// src/components/Gallery/Lightbox/LightboxControls.js
import React from 'react';

const LightboxControls = ({ 
  imageIndex, 
  totalImages, 
  onClose, 
  onNext, 
  onPrev, 
  isMobile,
  isTrueLandscape 
}) => {
  
  const buttonSize = isTrueLandscape ? '32px' : (isMobile ? '36px' : '50px');
  const fontSize = isTrueLandscape ? '14px' : (isMobile ? '16px' : '24px');
  const spacing = isTrueLandscape ? '5px' : (isMobile ? '10px' : '30px');

  return (
    <>
      {/* Navigation Arrows */}
      <button
        style={{
          position: 'absolute',
          left: spacing,
          top: '50%',
          transform: 'translateY(-50%)',
          background: 'rgba(255,255,255,0.9)',
          color: '#495057',
          border: '1px solid rgba(0,0,0,0.1)',
          borderRadius: '50%',
          width: buttonSize,
          height: buttonSize,
          fontSize: fontSize,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
          zIndex: 2001,
          backdropFilter: 'blur(10px)',
          transition: 'transform 0.1s ease'
        }}
        onClick={(e) => {
          e.stopPropagation();
          onPrev();
        }}
        onMouseEnter={(e) => e.target.style.transform = 'translateY(-50%) scale(1.05)'}
        onMouseLeave={(e) => e.target.style.transform = 'translateY(-50%) scale(1)'}
      >
        ◀
      </button>

      <button
        style={{
          position: 'absolute',
          right: spacing,
          top: '50%',
          transform: 'translateY(-50%)',
          background: 'rgba(255,255,255,0.9)',
          color: '#495057',
          border: '1px solid rgba(0,0,0,0.1)',
          borderRadius: '50%',
          width: buttonSize,
          height: buttonSize,
          fontSize: fontSize,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
          zIndex: 2001,
          backdropFilter: 'blur(10px)',
          transition: 'transform 0.1s ease'
        }}
        onClick={(e) => {
          e.stopPropagation();
          onNext();
        }}
        onMouseEnter={(e) => e.target.style.transform = 'translateY(-50%) scale(1.05)'}
        onMouseLeave={(e) => e.target.style.transform = 'translateY(-50%) scale(1)'}
      >
        ▶
      </button>

      {/* Close Button */}
      <button
        style={{
          position: 'absolute',
          top: isTrueLandscape ? '5px' : (isMobile ? '15px' : '20px'),
          right: isTrueLandscape ? '5px' : (isMobile ? '15px' : '20px'),
          background: 'rgba(255,255,255,0.9)',
          color: '#495057',
          border: '1px solid rgba(0,0,0,0.1)',
          borderRadius: '50%',
          width: isTrueLandscape ? '28px' : (isMobile ? '36px' : '40px'),
          height: isTrueLandscape ? '28px' : (isMobile ? '36px' : '40px'),
          fontSize: isTrueLandscape ? '16px' : (isMobile ? '20px' : '24px'),
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
          zIndex: 2001,
          opacity: isMobile ? 0.8 : 1,
          backdropFilter: 'blur(10px)',
          transition: 'transform 0.1s ease'
        }}
        onClick={onClose}
        onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
        onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
      >
        ×
      </button>

      {/* Image Counter */}
      <div
        style={{
          position: 'absolute',
          top: isTrueLandscape ? '5px' : (isMobile ? '15px' : '20px'),
          left: isTrueLandscape ? '5px' : (isMobile ? '15px' : '20px'),
          color: '#495057',
          fontSize: isTrueLandscape ? '10px' : (isMobile ? '11px' : '14px'),
          background: 'rgba(255,255,255,0.9)',
          padding: isTrueLandscape ? '3px 6px' : (isMobile ? '4px 8px' : '8px 12px'),
          borderRadius: '12px',
          border: '1px solid rgba(0,0,0,0.1)',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          zIndex: 2001,
          opacity: isMobile ? 0.8 : 1,
          backdropFilter: 'blur(10px)',
          fontWeight: '500'
        }}
      >
        {imageIndex + 1} / {totalImages}
      </div>
    </>
  );
};

export default LightboxControls;